import user from './UserReducer';
import { combineReducers } from 'redux';

export default combineReducers({
  user,
});
